import PropTypes from 'prop-types';

export const PledgeDataPropType = PropTypes.shape({
  amountPledged: PropTypes.number.isRequired,
  amountReceived: PropTypes.number.isRequired,
  pledgeDueDateString: PropTypes.string.isRequired,
  reconciledDonations: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number.isRequired,
      donationDateString: PropTypes.string.isRequired,
      donationId: PropTypes.string.isRequired,
    }),
  ),
});
